import { render, staticRenderFns } from "./MatchupOverviewMobile.vue?vue&type=template&id=76a1ff8f&scoped=true&"
import script from "./MatchupOverviewMobile.vue?vue&type=script&lang=js&"
export * from "./MatchupOverviewMobile.vue?vue&type=script&lang=js&"
import style0 from "./MatchupOverviewMobile.vue?vue&type=style&index=0&id=76a1ff8f&lang=scss&scoped=true&"
import style1 from "./MatchupOverviewMobile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a1ff8f",
  null
  
)

export default component.exports